/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useRef } from 'react';
import { Button, Modal } from 'antd';
import { useReactToPrint } from 'react-to-print';

import TM28 from './TM28';
import TM29 from './TM29';
import { ICndnFreeForm } from '@/interfaces/cndnFreeForm';

interface IProps {
  open: boolean;
  handleCancel: () => void;
  cndn: ICndnFreeForm;
  tms: string[];
}

const PrintModal = ({ open, handleCancel, cndn, tms }: IProps) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({
    contentRef,
    documentTitle: `${cndn?.code}`,
  });

  return (
    <Modal
      title="พิมพ์เอกสาร"
      open={open}
      width={'1100px'}
      onOk={() => handleCancel}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ปิด
        </Button>,
        <Button type="primary" key="print" onClick={() => handlePrint()}>
          พิมพ์เอกสาร
        </Button>,
      ]}
    >
      <div className="flex flex-col overflow-y-auto bg-gray-200 p-2 max-h-[600px] font-ibm gap-5">
        <div ref={contentRef} className="flex flex-col">
          {tms.includes('TM28') && <TM28 cndn={cndn} />}
          {tms.includes('TM28') && <TM29 cndn={cndn} />}
        </div>
      </div>
    </Modal>
  );
};

export default PrintModal;
